import axios from 'axios';

// API Gateway URL - Single entry point for all services
const GATEWAY_URL = import.meta.env.VITE_GATEWAY_URL || 'http://localhost:5003';

// Create API instance that goes through the Gateway
const createApiInstance = (baseURL: string) => {
  return axios.create({
    baseURL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// Single API instance through Gateway
const gatewayApi = createApiInstance(GATEWAY_URL);

// All API instances point to the gateway - it routes to appropriate services
const authApi = gatewayApi;       // Routes to /auth/* → Auth service (port 5001)
const staffApi = gatewayApi;      // Routes to /staff/* → Staff service (port 5002)
const clientApi = gatewayApi;     // Routes to /clients/* → Client service (port 5004)
const rosterApi = gatewayApi;     // Routes to /roster/* → Roster service (port 5005)

// Default API instance
const api = gatewayApi;

// Add request interceptor for authentication
const addAuthInterceptor = (apiInstance: any) => {
  apiInstance.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );
};

// Add response interceptor for error handling
const addResponseInterceptor = (apiInstance: any) => {
  apiInstance.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      // console.error('API Error:', {
      //   status: error.response?.status,
      //   message: error.message,
      //   url: error.config?.url,
      //   backend: '.NET',
      // });
      
      if (error.response?.status === 401) {
        // Check if this is likely a token expiration/authentication issue
        const isAuthRelated = error.config?.url?.includes('/auth/') ||
                             error.response?.data?.message?.toLowerCase()?.includes('token') ||
                             error.response?.data?.message?.toLowerCase()?.includes('unauthorized') ||
                             error.response?.data?.message?.toLowerCase()?.includes('expired');
        
        if (isAuthRelated) {
          //console.log('Authentication failed (401), logging out user');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          
          // Only redirect if we're not already on the login page
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        } else {
          // For other 401 errors, just log and let the component handle it
          console.warn('401 error (not auth related):', error.response?.data);
        }
      }
      
      return Promise.reject(error);
    }
  );
};

// Apply interceptors to all API instances
addAuthInterceptor(authApi);
addAuthInterceptor(staffApi);
addAuthInterceptor(clientApi);
addAuthInterceptor(rosterApi);

addResponseInterceptor(authApi);
addResponseInterceptor(staffApi);
addResponseInterceptor(clientApi);
addResponseInterceptor(rosterApi);

export default api;
export { authApi, staffApi, clientApi, rosterApi };